import { ApiError } from '@/lib/api/types';

let sessionTerminationStarted = false;

/** Returns true only for the first caller; used to dedupe logout on concurrent 401s. */
export function tryBeginSessionTermination(): boolean {
  if (sessionTerminationStarted) return false;
  sessionTerminationStarted = true;
  return true;
}

export function isLikelyAuthFailure(error: unknown): boolean {
  if (error instanceof ApiError && error.code === 'UNAUTHORIZED') return true;
  const e = error as { code?: string; details?: { status?: number } };
  if (e.details?.status === 401) return true;
  if (e.code === 'UNAUTHORIZED') return true;
  if (error instanceof Error) {
    const m = error.message.toLowerCase();
    if (m.includes('unauthorized') || m.includes('401')) return true;
    if (m.includes('authentication failed') || m.includes('session has expired')) return true;
  }
  return false;
}
